import { number, object, string, boolean } from 'yup'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

export interface DefaultValues {
  guid: string
  start: ImmutableVector3
  end: ImmutableVector3
  isIntersecting: boolean
  label?: string
}

// Schema for X or Y beams (horizontal)
export const xyBeamSchema = object({
  guid: string(),
  start: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  end: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  isXOrYCartesian: boolean().test({
    name: 'is-x-or-y-cartesian-beam',
    message:
      'Unterzug muss kartesisch in x oder y im Raum liegen. Das bedeutet dass der x-Wert derselbe für Start und Ende ist oder der y-Wert derselbe für Start und Ende ist. Außerdem muss der z-Wert derselbe für Start und Ende sein.',
    test: function () {
      const { start, end }: DefaultValues = this.parent

      const isEqualZ = start.z === end.z
      const isCartesian = start.x === end.x || start.y === end.y
      return isEqualZ && isCartesian
    },
  }),
})

// Schema for X/Y diagonal beams
export const xyDiagonalBeamSchema = object({
  guid: string(),
  start: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  end: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  isXYDiagonal: boolean().test({
    name: 'is-xy-diagonal-beam',
    message: 'Unterzug muss in x und y diagonal im Raum liegen, aber nicht in z.',
    test: function () {
      const { start, end }: DefaultValues = this.parent

      const isXYDiagonal = start.x !== end.x && start.y !== end.y
      const isHorizontal = start.z === end.z
      return isXYDiagonal && isHorizontal
    },
  }),
})
